import { CityDropdownForTrip, CommonButton, CommonInput, CommonModal, CustomSelect } from "components";
import { constant } from 'constants/constant';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { ButtonHeading, CustomPagination } from 'components'
import { deleteConsignorData } from '_services/accountsServices/consignorServices';
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { deleteZoneData, getZoneListData } from '_services/accountsServices/zoneServices';

import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import MastersFilterModal from 'modals/MastersFilterModal';
import { deleteVehicleGroupData, getVehicleGroupListData } from '_services/accountsServices/vehicleGroupServices';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import AddEditVehicleDocTypeModel from 'modals/AddEditVehicleDocTypeModel/AddEditVehicleDocTypeModel';
import { deleteVehicleDocData, getVehicleDocTypeListData } from '_services/accountsServices/vehicleDocTypeServices';
import { CiLock, CiUnlock } from 'react-icons/ci';
import { deleteItems, deleteStore, getItemsList, getPartCategoryList, getStoreList } from '_services/workShopServices/workShopServices';
import AddEditStoreModel from 'modals/AddEditStoreModel';
import { WorkshopAddItem } from 'modals';
import '../../pages/WorkShop/workshop.css'
import { utils } from "helper";

const objest = {
  description: "",
  store_id: {},
  quantity: '',
  rate: '',
  discount: '',
  tax: {},
  amount: ''
}
const AddWorkShopItemModal = (props) => {
  const { closeModal, onSubmitExpense, expenseType = '', partService = false, is_gst, expenseCategoryList, expenseList, callBackServiceData } = props;

  useDocumentTitle("Items | T360");

  const { settingChild } = useContext(UserContext);
  const settingChildVehicleGrp = settingChild?.find((i) => i?.label === "Vehicle Group");
  const [showAddItem, setShowAddItem] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [itemsDataList, setItemsDataList] = useState([])
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const prevFilterRef = useRef();
  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: '',
    part_category_id: {},
    type: expenseType == "Expenses" ? 1 : 2
  });

  const [debouncedSearch, setDebouncedSearch] = useState("");

  const total = totalItems;
  const start = (filter?.offset - 1) * filter?.limit + 1;
  const end = Math.min(filter?.offset * filter?.limit, total);

  useEffect(() => {
    const handler = setTimeout(() => {
      setFilter((s) => ({
        ...s,
        search: debouncedSearch,
        offset: 1
      }))
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [debouncedSearch]);

  const toggleItemsModelData = () => {
    setShowAddItem(!showAddItem);
  };

  const getDataItemList = async () => {
    setLoading(true);
    try {
      let object = {
        ...filter,
        type: expenseType ? expenseType : '',
        part_category_id: filter?.part_category_id?.value,
        company_id: StorageService.getCompanyId(),
        status: 1
      }
      const res = await getItemsList(object);
      if (res?.responseCode == 200) {
        setItemsDataList(res?.data?.itemData);
        setTotalItems(res?.data?.total_record);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  useEffect(() => {
    const prevFilter = prevFilterRef.current;
    if (
      JSON.stringify(prevFilter) !== JSON.stringify(filter)
    ) {
      getDataItemList();
      prevFilterRef.current = filter;
    }
  }, [filter, showAddItem, debouncedSearch])

  const deleteHandler = (item) => {
    setIsDelete(item)
  }

  const submitDeleteItems = async (itemData) => {
    setLoading(true);
    try {
      let object = {}
      if (itemData?.disable) {
        object['id'] = itemData?._id;
        object['status'] = (itemData?.status === 1) ? 3 : 1;
      } else {
        object['id'] = isDelete?._id;
        object['status'] = 2;
      }
      const res = await deleteItems(object);
      if (res?.responseCode == 200) {
        toast.success(`${res?.responseMessage}`);
        getDataItemList();
        setLoading(false);
        setIsDelete(false);
      } else {
        if (res?.responseMessage) {
          toast.error(res?.responseMessage);
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteItems,
    isLoadding: loading,
  }

  let storeModelProps = {
    isOpen: showAddItem,
    closeModal: (e) => setShowAddItem(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: showAddItem?.isDetails ? "View Store" : (showAddItem?._id ? 'Update Store' : 'Add Store'),
    submitTitle: showAddItem?.isDetails ? "View Store" : (showAddItem?._id ? 'Update Store' : 'Add Store'),
    footerPart: showAddItem?.isDetails ? true : false,
    hideFooterSumbmitBtn: showAddItem?.isDetails ? true : false,
    hideCompletelyFoolter: showAddItem?.isDetails ? true : false,
    ApiCall: getDataItemList
  }

  const columns = [
    { header: "Item Name", accessor: "item_name" },
    { header: "Code", accessor: "code" },
    { header: "Item Group", accessor: "category" },
    { header: "Quantity", accessor: "quantity" },
    // { header: "Part Type", accessor: "part_type" },
    // { header: "Inventory", accessor: "manage_inventory" },
    // { header: "Unit", accessor: "unit" },
    // { header: "Status", accessor: "status" },
    // { header: "Action", accessor: "action" }
  ];

  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      item_name: <span className='_tblText _style_ancer' onClick={(e) => setShowAddItem({ ...item, isDetails: true })}>
        <a className='_avPointer'>
          {item?.name ? item?.name : '-'} &nbsp;
        </a>
      </span>,
      code: <>{item?.code ? item?.code : '-'}</>,
      category: <>{item?.part_category_id?.name ? item?.part_category_id?.name : '-'}</>,
      item_type: <>{item?.type === 1 ? 'Parts' : 'Service'}</>,
      part_type: <>{item?.part_category_id?.part_type ? 'Multiple Type' : 'Single Type'}</>,
      manage_inventory: <>{item?.inventory ? 'Yes' : 'No'}</>,
      unit: <>{item?.type_unit ? item?.type_unit : '-'}</>,
      status: <div style={{ color: (item?.status === 1) ? "green" : "red" }}>{item?.status ? constant.ActionStore.find((el) => el?.value === item?.status)?.label : '-'}</div>,
      action: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "100px" }}
        >
          <div
            onClick={(e) => setShowAddItem(item)}
            className='_avPointer'
          >
            <span className='_samAnchor'>
              <span className='editIcon_avt'>
                <FiEdit color='blue' />
              </span>
            </span>
            {/* Edit */}
          </div>

          <div
            onClick={(e) => deleteHandler(item)}
            className='_avPointer'
          >
            <span className='_samAnchor'>
              <span className='deleteIcon_avt'>
                <FaRegTrashCan color='red' />
              </span>
            </span>
            {/* Delete */}
          </div>

          <div
            onClick={(e) => submitDeleteItems({ ...item, disable: true })}
            className='_avPointer'
          >
            {item?.status === 1 ? <CiUnlock color="green" size={20} /> : <CiLock color="red" size={20} />}
            {/* {item?.status === 1 ? 'Disable' : 'Enable'} */}
          </div>
        </div>
      ),
      quantity: <>
        {expenseList?.find((elemt) => elemt?._id === item?._id)?._id ?
          <button className="item_Csbtn_added"> Added </button>
          :
          <button className="item_Csbtn" onClick={(e) => onSubmitExpense({
            id: Date.now(),
            _id: item?._id,
            item_id: {
              label: item?.name,
              value: item?._id,
              rate: item?.rate || 0,
              quantity: item?.quantity || 0,
              hsn_code: item?.hsn_code || "", ...item
            }, ...objest
          })}> + Add </button>
        }
      </>
    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }))
  };

  const handleSubmit = () => { };

  const modalProps = {
    ...props,
    onSubmit: handleSubmit,
    footerPart: true,
    hideFooterSumbmitBtn: true,
    hideCompletelyFoolter: true,
  };

  const fetchPartCategoryList = useCallback(async (search, page, limit) => {
    try {
      const response = await getPartCategoryList({
        company_id: StorageService.getCompanyId(),
        offset: page,
        limit,
        search,
        status: 1
      });

      if (response?.responseCode === 200) {
        const vendors = response.data.partData.map(vendor => ({
          ...vendor,
          label: vendor.name,
          value: vendor._id
        }));

        return {
          items: vendors,
          total: response.data.total_record || vendors.length,
        };
      }

      toast.error(response?.responseMessage);
      return { items: [], total: 0 };
    } catch (error) {
      return { items: [], total: 0 };
    }
  }, []);

  return (
    <CommonModal {...modalProps}>
      <div className='pd_manufactoer'>
        <div className='__filtsTb_flexMain'>
          <div className='__filtsTb_flex'>
            <div className='__fInx_bx __fInx_bxFull'>
              <CommonInput
                type="search"
                label='Search Items'
                placeholder='Search Items'
                name='search'
                value={debouncedSearch} // filter.search
                maxLength="30"
                onInput={utils.maxLengthCheck}
                onChange={(e) => setDebouncedSearch(e.target.value)}
              />
            </div>
            <div className='__fInx_bx __fInx_bxFull'>
              <CityDropdownForTrip
                label="Select Category * "
                placeholder="Select Category * "
                fetchData={fetchPartCategoryList}
                pageSize={20}
                selectedItem={filter.part_category_id ? filter?.part_category_id : null}
                onChange={(data) => setFilter((s) => ({ ...s, part_category_id: data }))}
              />
            </div>
            {(filter.search || filter?.part_category_id?.value) ? <div>
              <button
                className='manuRsret'
                onClick={() => { setFilter((s) => ({ ...s, search: '', part_category_id: {} })); setDebouncedSearch("") }}
              >
                Clear
              </button>
            </div> : <></>}
            <CommonButton
              buttonTitle='Add New Item'
              className={!(filter.search || filter?.part_category_id?.value) ? "anime-btn _addComm_btn _exTtr_pdd" : "anime-btn _addComm_btn"}
              style={{ minHeight: '41px' }}
              onClick={(e) => toggleItemsModelData(e)}
            // disabled={disabled}
            />
          </div>
        </div>
      </div>
      <div className='_tabWith_outTab'>
        <BootstrapTable
          tableClass="__addItemTable_bx"
          columns={columns}
          data={rowListData(itemsDataList?.length > 0 ? itemsDataList : [])}
          isLoading={loading}
        />

        {itemsDataList?.length ? <div className='paginationFt_avt' style={{ alignItems: 'center' }}>
          <p style={{ fontSize: '13px', margin: '0px auto 0px 0px' }}>Showing {start} to {end} Records of {totalItems}</p>
          <CustomPagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={filter.offset}
            onPageChange={handlePageChange}
          />
        </div> : <></>}
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas mdOffcanvas ${showAddItem ? "show" : ""}`}
        tabIndex={-1}
        style={{ visibility: showAddItem ? "visible" : "hidden" }}
      >
        {showAddItem && (
          <WorkshopAddItem
            isOpen={showAddItem}
            onClose={(e) => setShowAddItem(false)}
            callListApi={(e) => getDataItemList(e)}
            expenseType={expenseType != '' ? expenseType : 1}
            showExpenseTypeDisable={partService ? false : true}
            callBackServiceData={callBackServiceData}
          />
        )}
      </div>
      <div className={showAddItem ? "offBack_drop" : ""}></div>
    </CommonModal>
  );
};

export default AddWorkShopItemModal;